import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { ChartComponent } from 'angular2-chartjs';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
const MersenneTwister = require('mersennetwister');

@Component({
  selector: 'app-reply-crash',
  template: `
    <div class="reply-loader" *ngIf="_loading || !data">
      <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
      <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
    </div>
    <div class="dice-game-content" *ngIf="!_loading && data">
      <chart [type]="'line'" [data]="chartData" [options]="options"></chart>

      <div class="crash-labels-wrap">
        <div class="crash-label">
          <p>Crashed at</p>
          <h5>x{{ data.multiplayer.multiplier.toFixed(3) }}</h5>
        </div>
        <div class="crash-label" *ngIf="data.win !== true && data.win !== undefined">
          <p>Player did not cashout at time</p>
        </div>
        <div class="crash-label" *ngIf="data.win === true">
          <p>Cashout at</p>
          <h5>x{{ data.cashout.toFixed(3) }}</h5>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .crash-labels-wrap {
        margin-top: 20px;
        display: flex;
        justify-content: space-around;
        width: 100%;
      }
      .crash-label {
        padding: 5px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        text-align: center;
        flex-basis: 48%;
        vertical-align: middle;
      }
      .crash-label h5 {
        margin-top: 0;
        margin-bottom: 0;
      }
      .crash-label p {
        margin-bottom: 0px;
      }
    `,
  ],
})
export class ReplyCrashComponent extends ReplyAbstractComponent implements OnChanges, AfterViewInit {
  data: any = null;
  sliderStyleBg: any;

  public chartData = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Player',
        backgroundColor: 'rgba(225,225,225,0)',
        borderColor: 'rgba(99, 190, 255, 1)',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        borderWidth: 5,
        pointRadius: 0,
        lineTension: 1,
      },
      {
        data: [],
        label: 'Chart',
        backgroundColor: 'rgba(225,225,225,0)',
        borderColor: 'rgba(148,159,177,1)',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        borderWidth: 5,
        pointRadius: 0,
        lineTension: 1,
      },
    ],
  };
  public options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
      labels: { fontColor: 'grey' },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: 'white',
            maxRotation: 0,
            maxTicksLimit: 1,
            callback: (label, index, labels) => {
              return Number(label).toFixed(1) + 's';
            },
          },
          gridLines: {
            color: 'hsla(0, 0%, 85%, .1)',
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: 'white',
            maxRotation: 0,
            min: 1,
            max: 1.5,
            maxTicksLimit: 4,
            callback: (label, index, labels) => {
              return Number(label).toFixed(1) + 'x';
            },
          },
          gridLines: {
            color: 'hsla(0, 0%, 85%, .1)',
          },
        },
      ],
    },
    layout: {
      height: '100%',
    },
    elements: {
      line: {
        tension: 0, // disables bezier curves
      },
    },
    animation: {
      duration: 1,
    },
  };

  @ViewChild(ChartComponent) component: ChartComponent;

  constructor(protected socket: SocketService, protected balanceHistory: BalanceHistoryService) {
    super(socket, balanceHistory);
  }

  ngAfterViewInit() {
    // this.component.chart.canvas.height = '100%';
    // this.component.chart.update();
  }

  protected initialize(data: any) {
    if (data.game !== 'crash') {
      this._error = true;
      return;
    }
    this.data = data;
    this.drawChart(data.multiplayer.number, data.multiplayer.multiplier, 1);
    if (data.win !== undefined) {
      if (!data.win) {
        this.chartData.datasets[0].borderColor = 'rgba(248, 93, 93, 1)';
      }
      this.drawChart(0, data.cashout, 0);
    }
    this._loading = false;
    this._error = false;
  }

  protected generateGame() {
    const data = {
      game: 'crash',
      multiplayer: {
        multiplier: null,
        number: this.generateLuckyNr(this.serverSeed, this.playerSeed),
      },
    };
    data.multiplayer.multiplier = this.formula(data.multiplayer.number);
    this.initialize(data);
  }

  drawChart(randomNr: number, multiplier: number, chartType: number) {
    if (chartType) {
      this.chartData.labels = [];
      this.chartData.datasets[0].borderColor = 'rgba(99, 190, 255, 1)';
      this.chartData.datasets[0].data = [];
      this.chartData.datasets[1].data = [];
      this.options.scales.yAxes[0].ticks.max = 1.5;

      if (multiplier > 1.5) {
        this.options.scales.yAxes[0].ticks.max = multiplier;
      }

      this.options = Object.assign({}, this.options);

      for (let i = 0; i < randomNr; i++) {
        if (chartType) {
          this.chartData.labels.push(i / 20);
        }
        this.chartData.datasets[chartType].data.push(this.formula(i));
      }
    } else {
      let i = 0;
      while (multiplier > this.formula(i)) {
        this.chartData.datasets[chartType].data.push(this.formula(i));
        i++;
      }
    }

    this.chartData = Object.assign({}, this.chartData);
  }

  formula(x: number, max: number = 500): number {
    return -(max / (x - max));
  }

  generateLuckyNr(serverSeed: string, clientSeed: string): number {
    if (!serverSeed || !clientSeed) {
      return null;
    }
    clientSeed = clientSeed.replace('0x', '');
    serverSeed = serverSeed.replace('0x', '');
    const clSeedSplitted = clientSeed.match(/.{1,6}/g);
    const srvSeedSplitted = serverSeed.match(/.{1,6}/g);
    const seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
    const seedsCominedNum = [];
    for (let i = 0; i < seedsCombined.length; i++) {
      seedsCominedNum[i] = parseInt(seedsCombined[i], 16);
    }

    const mt = new MersenneTwister();
    mt.seedArray(seedsCominedNum);
    return mt.int() % 500;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-crash.component.ts